export class PermissionKeys {
  // Data Upload
  public static readonly DataUploadRead = 'DataUpload - Read-only';
  public static readonly DataUploadEdit = 'DataUpload - Edit';
  public static readonly DataUploadAdd = 'DataUpload - Add';

  // Events
  public static readonly EventsView = 'Events - View';
  public static readonly EventsCreateEdit = 'Events - Create/Edit';
  public static readonly EventsReactivate = 'Events - Reactivate';

  // RCM
  public static readonly MaintenanceRead = 'Maintenance - Read-only';
  public static readonly MaintenanceEdit = 'Maintenance - Edit Analysis';
  public static readonly MaintenanceCreate = 'Maintenance - Create Analysis';

  // Maintenance Optimization
  public static readonly OptimizationRead = 'Maintenance Optimization - Read-only';
  public static readonly OptimizationCalculate = 'Maintenance Optimization - Calculate';
  public static readonly OptimizationSave = 'Maintenance Optimization - Save';

  // Claims
  public static readonly IsSecurity = 'isSecurity';
  public static readonly IsDefaultAdmin = 'isDefaultAdmin';
}
